import React from 'react';
import Pages from './basic_page';
class Communication extends Pages {
    render() {
        return (
    <>
            <h1 className='des_col'>
                Communication
            </h1>
        <div className='pageholder'>
        <div className='leftmenu'>
                <div>Communication</div>
                <button onClick={() => this.scroll(this.firstRef)}>Meetups</button>
                <button onClick={() => this.scroll(this.secondRef)}>See More</button>
            </div>
            <div className='righttext'>
            <div className='P2' ref={this.firstRef}>
                    <div className='text_wrap'>
                    <h3>Meetups</h3>
                    <h4>Online Meetup in June</h4>
                    <p>At the meetup, we had in-depth communication with BNUZH-China. They advised that our modeling was not only applicable to our project, but also could predict the behavior of other co-culture systems for bacteria and yeast, so as to demonstrate the popularization of the project. We also pointed out their potential shortcomings in plasmid design. After the meeting, we adopted the other's suggestions and made improvements to our own projects. </p >
                    <div className='img_wrap_icon'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-bnuzh.png"  alt=" colab-bnuzh" />
                    </div>
                    <h4>CCiC</h4>
                    <p>We attended the 9th Conference of China iGEMer Community (CCiC9), listening to a series of lectures and introduced our project. The judges promoted comments and suggestions for our project, which were later seriously considered and adopted for subsequent project improvement. </p >
                    <div className='img_wrap'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-ccic.png"  alt=" colab-ccic" />
                    </div>
                    <h4>2022 IGEM Beijing District Meeting </h4>
                    <p>We participated in the offline seminar of Beijing district hosted by iBowu-China, in which we shared our project progress and got acquainted with other teams, laying a foundation for further cooperation later on. </p>
                    <div className='img_wrap'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-ibowumeet.jpg" alt=" colab-ibowumeet"  />
                    </div>
                    <h4>TAP Synbio Art Workshop</h4>
                    <p>Together with CAFA_China and Tsinghua, we set up TAP Synbio Art workshop. We held regular exchange meetings online and discussed the relationship between biology and art. We put forward exhibition plans in combination with our own projects, and offered suggestions to each other, which were summarized by CAFA and formed a general curatorial scheme. In the near future, we plan to carry out an offline exhibition together. </p>
                    
                    <div className='img_wrap'>
                    < img src="https://static.igem.wiki/teams/4298/wiki/colab-tap.jpg"  alt=" colab-tap" />
                    </div>
                    <div className='img_wrap_icon'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-cafa.png"  alt=" colab-cafa" />
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-thu.jpg"  alt=" colab-thu" />
                    </div>
                    <h4>Tsinghua</h4>
                    <p>We had a dinner meeting with the Tsinghua team on July. They gave us suggestions to verify the role of co-culture system in our project. </p >
                    </div>
                </div>

                <div className='P2' ref={this.secondRef}>
					<div className='text_wrap'>
                        <a href='/peking/education'>
                            See more details in our Education pages
                        </a>
                    </div>
		</div>
        </div>
        </div>
    </>

  );
    }
};

export default Communication;

